import ProjectCard from '../../components/ProjectCard/ProjectCard'
import Layout from '../../components/Layout/Layout'
import './Projects.css'

export default function Projects() {
  return (
    <Layout>
      <div className='projects'>
        <h2 className='title'> <span className='crimson'>C</span>oding <span className='crimson'>P</span>rojects</h2>
        <ProjectCard className='cards' />
      </div>
    </Layout>
  )
}
